import classNames from 'classnames';
import check from '../assets/selection-checkmark.svg';
import transparentIndicator from '../assets/transparent-indicator.svg';
import styles from "./ColorTile.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ColorTile({
  color,
  active,
  onColorSelect
}) {
  const isTransparent = !color;
  return /*#__PURE__*/_jsxs("button", {
    className: classNames(styles.colorTile, {
      [styles.active]: active
    }),
    style: {
      backgroundColor: color ?? 'white'
    },
    onClick: () => onColorSelect?.(color),
    type: "button",
    children: [isTransparent && /*#__PURE__*/_jsx("img", {
      className: styles.transparentIndicator,
      src: transparentIndicator
    }), active && /*#__PURE__*/_jsx("img", {
      className: styles.image,
      src: check
    })]
  });
}